import React from 'react';
export function WhatIsIncluded() {
  const books = [{
    id: 1,
    title: 'Manuale di Yoga per Bambini',
    desc: 'Una guida semplice per comprendere lo yoga per bambini e applicare ogni attività passo dopo passo.',
    img: 'https://cdn.magicpatterns.com/uploads/tjgkzNkd3KeZC2JTS9FMDA/Tomo_1.png',
    bg: 'bg-blue-50'
  }, {
    id: 2,
    title: 'Giochi e Attività di Movimento Yoga',
    desc: 'Attività ludiche che aiutano i bambini a sviluppare equilibrio, coordinazione e concentrazione.',
    img: 'https://cdn.magicpatterns.com/uploads/f4Zd95gcYtK15ny8x2VRuN/Tomo_2.png',
    bg: 'bg-green-50'
  }, {
    id: 3,
    title: 'Diario di Mindfulness ed Emozioni',
    desc: 'Esercizi guidati per aiutare i bambini a riconoscere e gestire le emozioni.',
    img: 'https://cdn.magicpatterns.com/uploads/crX2ptMyf6Ln3wgTVHvb6J/Tomo_3.png',
    bg: 'bg-purple-50'
  }, {
    id: 4,
    title: 'Carte e Poster delle Posizioni Yoga',
    desc: 'Materiali visivi stampabili con le principali posizioni yoga per bambini.',
    img: 'https://cdn.magicpatterns.com/uploads/gsVEyfjnzcuvgW4HC3rG6m/Tomo_4.png',
    bg: 'bg-orange-50'
  }, {
    id: 5,
    title: 'Yoga per Famiglia e Scuola',
    desc: 'Routine e attività da utilizzare a casa o in classe per creare momenti di calma e connessione.',
    img: 'https://cdn.magicpatterns.com/uploads/1GeMRcLpmUHx4qsugtEApX/Tomo_5.png',
    bg: 'bg-teal-50'
  }];
  return <section className="py-16 px-4 bg-gray-50" data-id="element-247">
      <div className="max-w-4xl mx-auto" data-id="element-248">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-249">
          All'interno del Mega-Pack troverai 5 libri completi.
        </h2>

        <div className="space-y-6" data-id="element-250">
          {books.map(book => <div key={book.id} className={`flex flex-col md:flex-row items-center p-6 md:p-8 rounded-2xl shadow-md ${book.bg}`} data-id="element-251">
              <div className="w-full md:w-1/3 flex justify-center mb-6 md:mb-0 relative" data-id="element-252">
                <div className="absolute -top-4 -left-4 w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-xl shadow-lg z-10" data-id="element-253">
                  {book.id}
                </div>
                <img src={book.img} alt={book.title} className="w-48 md:w-full max-w-[200px] rounded-lg shadow-lg transform transition-transform hover:scale-105" data-id="element-254" />
              </div>
              <div className="w-full md:w-2/3 md:pl-10 text-center md:text-left" data-id="element-255">
                <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-256">
                  {book.title}
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed" data-id="element-257">
                  {book.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}